import {
  IconAtom,
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
} from '@assets/images/icon';
import { IconAnalyze, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { assetTracking1, workerTracking1 } from '@assets/images/main/rtls/product';

export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: '製品名' }, { text1: 'モバイルアクセス' }, { text2: '自動ドア出入り' }, { text3: '顔認識出入り' }],
    },
    {
      data: [
        { text: '説明' },
        { text: 'モバイルアプリで出入り口を制御する非常に簡単な機器' },
        { text: 'アプリ実行なしで便利なアクセスが可能な機器' },
        { text: '顔認識,NFCカードなど様々な出入りを一度に使用できる機器' },
      ],
    },
    {
      data: [{ text: '電源供給' }, { text: 'バッテリー使用(最大3年使用)' }, { text: 'DC 12V, 24V ' }, { text: 'DC 12V, 3A' }],
    },
  ],
  a: [
    { text: '通信帯域', icon: IconSignal },
    { text: '通信範囲', icon: IconCoil },
    { text: '精度', icon: IconRuler },
    { text: '資産検索', icon: IconSearch },
    { text: '角度測定(AoA)', icon: IconRuler },
    { text: '高精度追跡（ATDoA）', icon: IconAtom },

    { text: '電源', icon: IconPower },
    { text: '電池消費', icon: IconEnergyCircle },
    { text: '設置難易度', icon: IconTools },
    { text: '使用空間', icon: IconBuildings },
    { text: '推奨環境', icon: IconBookmark },
    { text: '特長', icon: IconPencil },
    { text: '外部連携', icon: IconShare },
  ],

  b: [
    { text: '3.1～10.6GHz' },
    { text: '<50m' },
    { text: '10cm以下' },
    { text: '1' },
    { text: '-' },
    { text: '1' },
    { text: 'PoE' },
    { text: '普通' },
    { text: '★★★' },
    { text: 'スマートファクトリー、港湾' },
    { text: '工場、物流倉庫、造船所、プラント、建設現場など' },
    { text: 'cm単位の超精密位置追跡が可能<br/>ノイズの多い環境でも動作' },
    { text: 'API提供' },
  ],

  c: [
    { text: '2.4GHz' },
    { text: '<30m' },
    { text: '10～30cm' },
    { text: '1' },
    { text: '1' },
    { text: '-' },
    { text: 'PoE' },
    { text: '低い' },
    { text: '★★☆' },
    { text: 'スマートビル、広い屋内' },
    { text: 'オフィス、病院、物流自動化、研究施設' },
    { text: '1台の設置で周辺タグの位置追跡が可能' },
    { text: 'API提供' },
  ],

  d: [
    { text: '2.4GHz' },
    { text: '最大100m' },
    { text: '10cm以上' },
    { text: '1' },
    { text: '-' },
    { text: '-' },
    { text: 'PoE' },
    { text: '非常に低い' },
    { text: '★☆☆' },
    { text: '倉庫、病院、資産管理スペースなど' },
    { text: '大規模資産管理' },
    { text: '導入コストが低い<br/>タグのバッテリー消耗が少ない' },
    { text: 'API提供' },
  ],

  e: [
    { text: '3.1～10.6GHz' },
    { text: '20m' },
    { text: '10～30cm' },
    { text: '-' },
    { text: '-' },
    { text: '1' },
    { text: '充電式バッテリー' },
    { text: '高い' },
    { text: '★☆☆' },
    { text: '小規模デモ、仮設スペース' },
    { text: '一時的な使用現場、小規模スペース、インフラ工事が困難な場所' },
    { text: 'アンカー設置不要<br/>高い携帯性' },
    { text: '非提供（アプリ専用）' },
  ],
  spec: [
    {},
    {
      image: schemeUwb,
      link: '/jp/rtls/uwb',
      title: 'TwinTracker UWB',
      desc: 'UWB',
    },
    {
      image: schemeAoa,
      link: '/jp/rtls/aoa',
      title: 'TwinTracker AoA',
      desc: 'BLE + AoA',
    },
    {
      image: schemeBle,
      link: '/jp/rtls/ble',
      title: 'TwinTracker BLE',
      desc: 'BLE',
    },
    {
      image: schemeComfort,
      link: '/jp/rtls/comfort',
      title: 'Comfort Kit',
      desc: 'UWB',
    },
  ],
};
